import React from "react";
import "./assets/css/header.css";
import "./assets/css/login.css";
import logoImage from "./assets/logo4.svg";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { SignInHeader } from "./components/Header/SignInHeader";
import { BsArrowRight } from "react-icons/bs";

function RegisterChoice() {
  const navigate = useNavigate();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const signInClick = () => navigate("/login");
  const handleLogoClick = () => navigate("/");

  const linkButtonStyle = {
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    color: "inherit",
    font: "inherit",
    textDecoration: "underline",
  };

  const logoButtonStyle = {
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
  };

  return (
    <div>
      <div className="nav bg-white">
        <div className="container-fluid">
          <div className="row navpad">
            <div className="d-flex justify-content-between">
              <div className="col-lg-4 logosearch">
                <button
                  type="button"
                  onClick={handleLogoClick}
                  style={logoButtonStyle}
                  aria-label="Home"
                >
                  <img src={logoImage} alt="Logo" />
                </button>
              </div>
              <div className="col-lg-8 d-flex justify-content-end align-items-center">
                {isTabletOrMobile ? (
                  <SignInHeader text="LOGIN" handlerClick={signInClick} />
                ) : (
                  <div className="postbtn">
                    <button type="button" onClick={signInClick}>
                      LOGIN
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mainbg">
        <div className="form">
          <div className="formdata">
            <h2>Sign up</h2>
            <p>Choose how you would like to create your account.</p>

            <div className="formbtn">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                  marginTop: 8,
                }}
              >
                <button type="button" onClick={() => navigate("/jobseeker_signup")}>
                  Job seeker
                </button>
                <button
                  type="button"
                  onClick={() => navigate("/Request_For_Subscription")}
                >
                  Employer
                </button>
              </div>
              <p style={{ marginTop: 20 }}>
                Already have an account?{" "}
                <button type="button" onClick={signInClick} style={linkButtonStyle}>
                  Sign in
                </button>
              </p>
              <p style={{ marginTop: 12, textAlign: "center" }}>
                <button type="button" onClick={handleLogoClick} style={linkButtonStyle}>
                  Back to home <BsArrowRight />
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterChoice;
